<div class="page-email">
  <div class="row">
    <div class="col">
      <fx-tab
        [tabs]="tabs"
        [activeTab]="currentTabActive"
        (selected)="onChangeTab($event)"></fx-tab>
    </div>
  </div>
  <div class="fx-panel bg-dark-lighter">
    <div class="fx-panel-body">
      <form class="form form-horizontal" #form="ngForm">
        <fx-option-send *ngIf="tabSelected == 'other'"> </fx-option-send>
        <ng-container *ngIf="tabSelected == 'all_user_specific_ib'">
          <div class="row position-relative">
            <div class="col-12 col-lg-2">
              <label class="text-white lb-header" for="cpName">Campaign Name <i class="required-symbol">*</i> </label>
            </div>
            <div class="col-12 col-lg-10">
              <input #cpName name="cpName" id="cpName" maxlength="256" class="w-100 p-calendar-w-btn crg-base-input" [(ngModel)]="campaignName" />
            </div>
            <div class="rest-hint">{{cpName.value.length}}/256</div>
          </div>
          <div class="row mt-4">
            <div class="col-12 col-lg-2 ">
              <label class="text-white lb-header">From <i class="required-symbol">*</i></label>
            </div>
            <div class="col-12 col-lg-10">
              <select
                style="min-width: 200px"
                class="selector p-calendar-w-btn crg-base-input text-white"
                name="ddlEmailType"
                [(ngModel)]="condition.emailType"
              >
                <option
                  [ngValue]="item.value"
                  *ngFor="let item of emailTypes"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12 col-lg-2 d-flex align-items-start">
              <label class="text-white lb-header mb-3" style="height: 24px">To<i class="required-symbol">*</i></label>
            </div>
            <div class="col-12 col-lg-10">
              <span class="fx-radio text-white">
                <input type="radio" name="radioOption" [(ngModel)]="condition.option" [value]="0" />
                <span class="checkmark"></span>
                <label>Specified IBs</label>
              </span>
              <span class="fx-radio text-white mt-2">
                <input type="radio" name="radioOption" [(ngModel)]="condition.option" [value]="1" />
                <span class="checkmark"></span>
                <label>IBs' Direct Child Traders</label>
              </span>
              <span class="fx-radio text-white mt-2">
                <input type="radio" name="radioOption" [(ngModel)]="condition.option" [value]="2" />
                <span class="checkmark"></span>
                <label>Full IB Network</label>
              </span>
              <div class="position-relative">
                <textarea
                  #content
                  rows="3"
                  class="w-100 mh-100 p-calendar-w-btn text-white p-2 mt-3"
                  name="userSpecific"
                  [(ngModel)]="data.userSpecific"
                ></textarea>
                <div class="csplaceholder" (click)="content.focus()" *ngIf="data?.userSpecific?.length === 0">
                  Enter IB email. <br>Multiple emails can be entered at once, separated by comma
                </div>
              </div>
              <p class="text-red mb-0 mt-2">*Multiple emails can be entered at once, separated by comma</p>
              <p class="text-red mb-0 mt-2">EX. [abc@gmail.com, xy@yopmail.ez]</p>
              <div class="row mt-3">
                <div class="col">
                  <fx-import-csv (dataLoaded)="import($event)"></fx-import-csv>
                  <button
                    mat-button
                    class="btn bg-common ms-3"
                    (click)="
                      data.keyword = '';
                      pageInfo.pageIndex = 1;
                      postPreviewEmailMarketing()
                    "
                  >
                    Preview
                  </button>
                </div>
              </div>
              <ng-container *ngIf="listPreview?.length > 0">
                <div class="row mt-3">
                  <div class="col">
                    <label class="text-white">Preview All Emails </label>
                  </div>
                </div>
                <div class="row my-3">
                  <div class="col-12">
                    <div class="input-group search-group">
                      <input
                        type="text"
                        class="form-control text-black"
                        name="keyword"
                        placeholder="Search Transaction"
                        [(ngModel)]="data.keyword"
                        (keyup)="searchEmail($event)"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn bg-common"
                          type="button"
                          (click)="searchEmail('click')"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="table-responsive mt-3">
                      <table class="rox-table table-bordered bg-dark w-100">
                        <thead>
                          <tr>
                            <th class="text-center">ID</th>
                            <th class="text-center">User Name</th>
                            <th class="text-center">User Name (JP)</th>
                            <th class="text-center">Email</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of listPreview | paginate : {
                                  id: 'email_marketing',
                                  itemsPerPage: pageInfo.pageSize,
                                  currentPage: pageInfo.pageIndex,
                                  totalItems: pageInfo.totalRecord
                                }"
                          >
                            <td class="text-center">{{ item.id }}</td>
                            <td class="text-center">{{ item.getUserName() }}</td>
                            <td class="text-center">{{ item.getUserNameJP() }}</td>
                            <td class="text-center">{{ item.email }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="row mt-15">
                  <div class="col">
                    <div class="pagination-wrapper">
                      <pagination-controls
                        id="email_marketing"
                        (pageChange)="pageChanged($event)"
                        autoHide="true"
                        responsive="true"
                        previousLabel="Prev"
                        nextLabel="Next"
                      >
                      </pagination-controls>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="row mt-4 pos-relative">
            <div class="col-12 col-lg-2">
              <label for="subAllInp" class="text-white lb-header">Subject <i class="required-symbol">*</i></label>
            </div>
            <div class="col-12 col-lg-10">
              <input id="subAllInp" name="subAll" #sj class="w-100 p-calendar-w-btn crg-base-input" maxlength="256" [(ngModel)]="data.subAll" />
            </div>
            <div class="rest-hint">{{sj.value.length}}/256</div>
          </div>
          <div class="row mt-4">
            <div class="col-12 col-lg-2  d-flex align-items-start">
              <label class="text-white lb-header" for="areaAll" style="height: fit-content">Content<i class="required-symbol">*</i></label>
            </div>
            <div class="col-12 col-lg-10">
              <textarea
                name="areaAll"
                id="areaAll"
                class="w-100 text-white"
              ></textarea>
              <div id="fill-content" class="d-none"></div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12 col-lg-2">
              <label class="text-white lb-header">Send Date <i class="required-symbol">*</i></label>
            </div>
            <div class="col-12 col-lg-10">
              <p-calendar
                name="schedulerDate"
                [(ngModel)]="schedulerDate"
                required
                #from="ngModel"
                [placeholder]="'dd/mm/yyyy HH:mm'"
                [dateFormat]="'dd/mm/yy'"
                [timeOnly]="false"
                [showIcon]="true"
                [showSeconds]="false"
                [showTime]="true"
                [minDate]="minDate"
                inputStyleClass="form-control past-picker-disabled"
                class="schedule_time_picker past-picker-disabled"
              ></p-calendar>
              <br>
              <p class="text-red mb-0 mt-2">*Email will be sent automatically at the time scheduled above if set.</p>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12 col-lg-2">
            </div>
            <div class="col-12 col-lg-10">
              <button
                mat-button
                data-bs-toggle="modal"
                data-bs-target="#modalPreviewEmail"
                class="btn bg-common me-3"
                (click)="preview()"
              >
                Preview
              </button>
              <button mat-button class="btn bg-common" (click)="postSendEmailMarketing()">
                Save & Send
              </button>
            </div>
          </div>
        </ng-container>
      </form>
    </div>
  </div>
</div>

<div class="modal fade fx-modal" id="modalPreviewEmail" #modalPreviewEmail>
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-bs-dismiss="modal">
          &times;
        </button>
        <div class="container">
          <table>
            <tr>
              <td class="text-center" colspan="2">
                <img  style="width:160px" src="assets/images/logo_dark.png" />
                <hr />
              </td>
            </tr>
          </table>
          <h3>様</h3>
          <ng-container *ngIf="previewData.content">
            <div [innerHtml]="previewData.content"></div
          ></ng-container>
          <hr />
          <p>
            <img style="width:160px" src="assets/images/logo_dark.png" />
          </p>
          <div>
            <span class="font-bold">Address:&nbsp;</span>Suite 305, Griffith Corporate Centre, Beachmont, P.O. Box 1510, Kingstown, Saint Vincent and the Grenadines.
          </div>
          <div>
            <span class="font-bold">URL:&nbsp;</span
            ><a href="https://cryptograph.finance" target="_blank" class="text-red italic">cryptograph.finance</a>
          </div>
          <p class="text-muted">
            ※この電子メール及び添付書類は、秘密情報を含んでいる可能性があり、名宛人以外の方による利用や内容の公表、複写、転用等は厳禁です。<br>
            誤送信メールを受け取られた場合、直ちに発信人に返信でお知らせ頂くと同時に、メールの削除をお願い申し上げます。
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
